import Keycloak from 'keycloak-js';

import { CONFIG } from '@/constants';

const initOptions = {
  url: CONFIG.KEYCLOAK.URL,
  realm: CONFIG.KEYCLOAK.REALM,
  clientId: CONFIG.KEYCLOAK.CLIENT_ID,
};

const keycloak = new Keycloak(initOptions);

let refreshIntervalId;

export default {
  async initAuth({ commit, dispatch }) {
    commit('setLoading', true);
    await dispatch('authenticate');
    commit('setLoading', false);
  },
  async authenticate({ commit, dispatch }) {
    await dispatch('setupClient');
    if (keycloak.authenticated) {
      commit('setToken', keycloak.token);
      await dispatch('fetchProfile');
    }
  },
  async setupClient({ commit, dispatch }) {
    try {
      await keycloak.init({
        onLoad: CONFIG.KEYCLOAK.ON_LOAD.CHECK_SSO,
        checkLoginIframe: false,
      });
      refreshIntervalId = setInterval(async () => {
        await dispatch('refreshToken');
      }, CONFIG.KEYCLOAK.REFRESH_TOKEN_TIME * 1000);
    } catch (error) {
      commit('setToken', '');
    }
  },
  async refreshToken({ commit }) {
    try {
      const response = await keycloak.updateToken(70);
      if (response) {
        commit('setToken', keycloak.token);
      }
    } catch (error) {
      commit('setToken', '');
    }
  },
  async fetchProfile({ commit }) {
    try {
      const profile = await keycloak.loadUserProfile();
      commit('setProfile', profile);
    } catch (error) {
      commit('setError', error);
    }
  },
  async logOut({ commit }) {
    clearInterval(refreshIntervalId);
    try {
      await keycloak.logout();
      commit('reset');
    } catch (error) {
      commit('setError', error);
    }
  },
};
